import React from 'react';
import { cn } from '../../utils/cn';

const SkeletonLoader = ({ className, variant = 'default' }) => {
  if (variant === 'photo-card') {
    return (
      <div className={cn('bg-white rounded-2xl shadow-md overflow-hidden animate-pulse', className)}>
        {/* Rank Badge Skeleton */}
        <div className="absolute top-4 left-4 z-10">
          <div className="w-12 h-12 bg-gray-300 rounded-full"></div>
        </div>
        
        {/* Image Skeleton */}
        <div className="aspect-square bg-gradient-to-br from-gray-200 to-gray-300"></div>
        
        {/* Content Skeleton */}
        <div className="p-4 space-y-3">
          {/* Score Bar */}
          <div className="flex items-center justify-between">
            <div className="h-4 bg-gray-300 rounded w-24"></div>
            <div className="h-6 bg-gray-300 rounded w-12"></div>
          </div>
          
          {/* Criteria Bars */}
          <div className="space-y-2">
            <div className="h-3 bg-gray-200 rounded w-full"></div>
            <div className="h-3 bg-gray-200 rounded w-full"></div>
            <div className="h-3 bg-gray-200 rounded w-5/6"></div>
          </div>
          
          {/* Action Buttons */}
          <div className="flex gap-2 pt-2">
            <div className="h-8 bg-gray-200 rounded flex-1"></div>
            <div className="h-8 bg-gray-200 rounded flex-1"></div>
          </div>
        </div>
      </div>
    );
  }
  
  // Default skeleton
  return (
    <div className={cn('animate-pulse bg-gray-200 rounded', className)}></div>
  );
};

export default SkeletonLoader;